function escapeXml(str: string): string {
  return str
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&apos;');
}

function buildEndDispositionXml(disposition?: {
  dispositionCode: string;
  dispositionName: string;
  notes?: string;
}): { subject: string; dispositionXml: string } {
  const subject = disposition ? `Call: ${disposition.dispositionName}` : 'Inbound Call';
  const dispositionXml = disposition
    ? `
  <Subject>${escapeXml(subject)}</Subject>
  <Text>${escapeXml(disposition.notes || '')}</Text>
  <Custom_1>${escapeXml(disposition.dispositionCode)}</Custom_1>
  <Custom_2>${escapeXml(disposition.dispositionName)}</Custom_2>`
    : `
  <Subject>Inbound Call</Subject>`;

  return { subject, dispositionXml };
}

export { escapeXml, buildEndDispositionXml };
